import LanguageList from './LanguageList'

export default LanguageList
